<template>
  <transition name="promo">
    <div v-if="open" class="promo" @click.self="close">
      <div
        ref="dialog"
        class="promo__card"
        role="dialog"
        aria-modal="true"
        aria-labelledby="promo-titulo"
        tabindex="-1"
      >
        <button
          ref="closeBtn"
          type="button"
          class="promo__close"
          aria-label="Cerrar"
          @click="close"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" aria-hidden="true" focusable="false">
            <path d="M6 6l12 12M18 6L6 18" />
          </svg>
        </button>

        <span class="promo__stripe promo__stripe--a" aria-hidden="true"></span>
        <span class="promo__stripe promo__stripe--b" aria-hidden="true"></span>

        <p class="promo__tag">Promo</p>

        <h2 id="promo-titulo" class="promo__title">
          <span class="promo__num">{{ promo.porcentaje }}%</span>
          <span class="promo__off">{{ promo.titulo }}</span>
        </h2>

        <p class="promo__text">{{ promo.texto }}</p>

        <a
          class="btn btn--green promo__btn"
          :href="url"
          target="_blank"
          rel="noopener noreferrer"
          @click="close"
        >{{ promo.boton }}</a>
      </div>
    </div>
  </transition>
</template>

<script>
import { PROMO, whatsappUrl } from '../config';

const CLAVE = 'cb-promo-vista';

export default {
  name: 'PromoPopup',
  data() {
    return {
      open: false,
      promo: PROMO,
      timer: null,
    };
  },
  computed: {
    url() {
      return whatsappUrl(PROMO.mensaje);
    },
  },
  methods: {
    yaVista() {
      // Si el navegador bloquea el almacenamiento, se muestra igual.
      try {
        return window.sessionStorage.getItem(CLAVE) === '1';
      } catch (e) {
        return false;
      }
    },
    marcarVista() {
      try {
        window.sessionStorage.setItem(CLAVE, '1');
      } catch (e) {
        /* sin almacenamiento: no pasa nada */
      }
    },
    show() {
      this.open = true;
      document.documentElement.style.overflow = 'hidden';
      this.$nextTick(() => {
        if (this.$refs.dialog) this.$refs.dialog.focus({ preventScroll: true });
      });
    },
    close() {
      if (!this.open) return;
      this.open = false;
      document.documentElement.style.overflow = '';
      this.marcarVista();
    },
    onKeydown(event) {
      if (event.key === 'Escape') this.close();
    },
  },
  mounted() {
    if (!PROMO.activa || this.yaVista()) return;
    this.timer = window.setTimeout(this.show, PROMO.demora);
    window.addEventListener('keydown', this.onKeydown);
  },
  beforeUnmount() {
    window.clearTimeout(this.timer);
    window.removeEventListener('keydown', this.onKeydown);
    document.documentElement.style.overflow = '';
  },
};
</script>

<style scoped>
.promo {
  position: fixed;
  inset: 0;
  z-index: 200;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: max(20px, env(safe-area-inset-top)) max(20px, env(safe-area-inset-right))
    max(20px, env(safe-area-inset-bottom)) max(20px, env(safe-area-inset-left));
  background: rgba(2, 30, 18, 0.62);
  overflow-y: auto;
}

.promo__card {
  position: relative;
  overflow: hidden;
  width: 100%;
  max-width: 420px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  padding: 44px 28px 32px;
  border-radius: 32px;
  background: #ffffff;
  border: 2.5px solid var(--green);
  box-shadow: 10px 10px 0 var(--green);
  text-align: center;
  color: var(--green);
  outline: none;
}

/* Franjas diagonales de la marca */
.promo__stripe {
  position: absolute;
  top: -30px;
  bottom: -30px;
  transform: skewX(-22deg);
  pointer-events: none;
  background: #e6f2ea;
}

.promo__stripe--a {
  right: 10%;
  width: 54px;
}

.promo__stripe--b {
  right: calc(10% + 80px);
  width: 26px;
  background: #eef6f1;
}

.promo__card > *:not(.promo__stripe) {
  position: relative;
}

.promo__close {
  position: absolute !important;
  top: 12px;
  right: 12px;
  width: 44px;
  height: 44px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 50%;
  background: var(--green);
  color: #ffffff;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  z-index: 2;
}

.promo__tag {
  margin: 0;
  padding: 6px 14px;
  border-radius: 999px;
  background: #e3f3e9;
  border: 1px solid #9ed3b2;
  font-family: var(--mono);
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--green-mid);
}

.promo__title {
  margin: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 1;
}

.promo__num {
  font-family: var(--display);
  font-weight: 800;
  font-size: clamp(72px, 24vw, 104px);
  letter-spacing: -0.04em;
  color: var(--green);
}

.promo__off {
  margin-top: 6px;
  font-family: var(--display);
  font-weight: 800;
  font-size: clamp(20px, 6vw, 26px);
  color: var(--green);
}

.promo__text {
  margin: 4px 0 8px;
  max-width: 290px;
  font-size: 18px;
  font-weight: 600;
  line-height: 1.35;
  color: var(--muted);
  text-wrap: balance;
}

.promo__btn {
  width: 100%;
  padding: 18px 20px;
  font-size: 17px;
}

/* Animación de entrada */
.promo-enter-active,
.promo-leave-active {
  transition: opacity 0.22s ease;
}

.promo-enter-active .promo__card,
.promo-leave-active .promo__card {
  transition: transform 0.25s cubic-bezier(0.2, 0.8, 0.2, 1);
}

.promo-enter-from,
.promo-leave-to {
  opacity: 0;
}

.promo-enter-from .promo__card,
.promo-leave-to .promo__card {
  transform: translateY(18px) scale(0.96);
}

@media (max-width: 560px) {
  .promo__card {
    padding: 44px 22px 26px;
    border-radius: 28px;
    box-shadow: 8px 8px 0 var(--green);
  }
}
</style>
